<pr-status-label [dense]="dense" [label]="label" [color]="colour" />
